import styled from "@emotion/styled";
import { padding } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";

const Button = styled.button(({ theme }) => ({
  ...theme.typography.BodySmallSB,
  ...padding(theme.spacing.SML.xsml, theme.spacing.SML.sml),
  textAlign: "left",
  color: theme.colors.content.primary,
  background: "none",
  border: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: `1px solid ${theme.colors.border.default}`,
  width: "100%",
  cursor: "pointer",
  svg: {
    fill: theme.colors.accent.primary.background.default,
  },
}));

const Subtitle = styled.span(({ theme }) => ({
  ...theme.typography.BodySmallM,
  color: theme.colors.content.tertiary,
}));

interface Props {
  title: string;
  subtitle?: string | null;
  onClick: () => void;
}

export default function ItemButton({ title, subtitle, onClick }: Props) {
  return (
    <Button type="button" onClick={() => onClick()}>
      <Container as="span" direction="column" alignItems="flex-start">
        {title}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Container>
      <svg
        width="6"
        height="10"
        viewBox="0 0 6 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 5L1.12812 10L-3.99932e-07 9.14938L4.04306 5L-3.71818e-08 0.850619L1.12812 -2.12957e-07L6 5Z"
        />
      </svg>
    </Button>
  );
}
